import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const customId = "custom-id-yes";

export const getAllProducts = createAsyncThunk(
  "products/listAllProducts",
  async (_, { rejectWithValue, getState }) => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/product/all/admin`, {});
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);

export const listProducts = createAsyncThunk(
  "products/listProducts",
  async (store, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.get(
        `${BASE_URL}/product/seller?store_id=${store}`,
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);

export const productDetails = createAsyncThunk(
  "products/productDetails",
  async (slug, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.get(
        `${BASE_URL}/product/seller?slug=${slug}`,
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);

export const productVariant = createAsyncThunk(
  "products/productVariant",
  async (productId, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.get(
        `${BASE_URL}/product/variant/?product_id=${productId}`,
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async (body, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      await Axios.post(
        `${BASE_URL}/product/update/?product_id=${body.id}`,

        {
          category_id: body.category_id,
          name: body.name,
          description: body.description,
        },

        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Product updated successfully", {
        toastId: customId,
      });
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (product, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(`${BASE_URL}/product/create`, product, {
        headers: {
          authorization: `Bearer ${userInfo?.data?.accessToken}`,
        },
      });
      toast.success("Product created successfully", {
        toastId: customId,
      });
      sessionStorage.setItem("newProduct", JSON.stringify(data));
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const createProductVariant = createAsyncThunk(
  "products/createProductVariant",
  async (product, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(
        `${BASE_URL}/product/variant/create`,
        product,
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Variant created successfully", {
        toastId: customId,
      });

      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const updateProductVariant = createAsyncThunk(
  "products/updateProductVariant",
  async (product, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(
        `${BASE_URL}/product/variant/update?product_variant_id=${product.product_variant_id}`,
        { img_urls: product.img_urls },
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Variant updated successfully", {
        toastId: customId,
      });

      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const createProductSpec = createAsyncThunk(
  "products/createProductSpec",
  async (product, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(
        `${BASE_URL}/product/variant/spec/create`,
        product,
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Spec created successfully", {
        toastId: customId,
      });
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const updateProductSpec = createAsyncThunk(
  "products/updateProductSpec",
  async (product, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(
        `${BASE_URL}/product/variant/spec/update?product_variant_spec_id=${product.product_variant_spec_id}`,
        {
          quantity: product.quantity,
          amount: product.amount,
          size: product.size,
        },
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Spec created successfully", {
        toastId: customId,
      });
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (productId, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      await Axios.delete(`${BASE_URL}/product/delete?product_id=${productId}`, {
        headers: {
          authorization: `Bearer ${userInfo?.data?.accessToken}`,
        },
      });
      toast.success("Product successfully deleted!", {
        toastId: customId,
      });
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

export const activateProduct = createAsyncThunk(
  "products/activateProduct",
  async (productId, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      await Axios.post(
        `${BASE_URL}/product/activate/?product_id=${productId}`,
        { product_id: productId },
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Product successfully activated!", {
        toastId: customId,
      });
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);
export const deactivateProduct = createAsyncThunk(
  "products/deactivateProduct",
  async (productId, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      await Axios.post(
        `${BASE_URL}/product/deactivate/?product_id=${productId}`,
        { product_id: productId },
        {
          headers: {
            authorization: `Bearer ${userInfo?.data?.accessToken}`,
          },
        }
      );
      toast.success("Product successfully deactivated!", {
        toastId: customId,
      });
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err, {
        toastId: customId,
      });
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  loading: false,
  error: false,
  newProduct: {},
  newVariant: {},
  newSpec: {},
  updateSuccess: false,
  postSuccess: false,
  createVariantSuccess: false,
  createSpecSuccess: false,
  updateVariantSuccess: false,
  updateSpecSuccess: false,
  deleteSuccess: false,
  products: [],
  productVariant: {},
  product: {},
};

export const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    productReset: (state) => {
      state.loading = false;
      state.deleteSuccess = false;
      state.postSuccess = false;
      state.updateSuccess = false;
      state.createVariantSuccess = false;
      state.updateVariantSuccess = false;
      state.createSpecSuccess = false;
      state.updateSpecSuccess = false;
    },
  },
  extraReducers: {
    [getAllProducts.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [getAllProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.products = action?.payload;
    },
    [getAllProducts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },

    [listProducts.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [listProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.products = action?.payload;
    },
    [listProducts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },

    [productDetails.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [productDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.product = action?.payload;
    },
    [productDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },

    [productVariant.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [productVariant.fulfilled]: (state, action) => {
      state.loading = false;
      state.productVariant = action?.payload;
    },
    [productVariant.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [updateProduct.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [updateProduct.fulfilled]: (state) => {
      state.loading = false;
      state.updateSuccess = true;
    },
    [updateProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [createProduct.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [createProduct.fulfilled]: (state, action) => {
      state.loading = false;
      state.postSuccess = true;
      state.newProduct = action.payload;
    },
    [createProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [createProductVariant.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [createProductVariant.fulfilled]: (state, action) => {
      state.loading = false;
      state.createVariantSuccess = true;
      state.newVariant = action.payload;
    },
    [createProductVariant.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [updateProductVariant.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [updateProductVariant.fulfilled]: (state, action) => {
      state.loading = false;
      state.updateVariantSuccess = true;
      state.newVariant = action.payload;
    },
    [updateProductVariant.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [createProductSpec.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [createProductSpec.fulfilled]: (state, action) => {
      state.loading = false;
      state.createSpecSuccess = true;
      state.newSpec = action.payload;
    },
    [createProductSpec.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [updateProductSpec.fulfilled]: (state, action) => {
      state.loading = false;
      state.updateSpecSuccess = true;
    },
    [updateProductSpec.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [updateProductSpec.fulfilled]: (state, action) => {
      state.loading = false;
      state.createSpecSuccess = true;
      state.newSpec = action.payload;
    },
    [deleteProduct.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [deleteProduct.fulfilled]: (state) => {
      state.loading = false;
      state.deleteSuccess = true;
    },
    [deleteProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [activateProduct.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [activateProduct.fulfilled]: (state) => {
      state.loading = false;
      state.postSuccess = true;
    },
    [activateProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [deactivateProduct.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [deactivateProduct.fulfilled]: (state) => {
      state.loading = false;
      state.postSuccess = true;
    },
    [deactivateProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { reducer, actions } = productSlice;
export const { productReset } = actions;

export default reducer;
